import { useEffect } from "react";
import { Box, Button } from "@mantine/core";
import {
  GhostButton, Prompt, Screen, StatusDot,
  LoadError,
}  from "../components/primitives";
import { useConsoleStore } from "../stores/consoleStore";
import { useUiStore } from "../stores/uiStore";
import { useWorkspaceStore } from "../stores/workspaceStore";
import { compact } from "../lib/vf";
import css from "./screens.module.css";

export default function Repos() {
  const openModal = useUiStore((s) => s.openModal);
  const openDetail = useUiStore((s) => s.openDetail);
  const workspaceId = useWorkspaceStore((s) => s.currentId);
  const repos = useConsoleStore((s) => s.repos);
  const loadError = useConsoleStore((s) => s.errors.repos);
  const load = useConsoleStore((s) => s.loadRepos);

  useEffect(() => {
    if (workspaceId) void load();
  }, [workspaceId, load]);

  return (
    <Screen>
      <Prompt
        command="vf code repos ls"
        comment="# /v1/code"
        action={<GhostButton onClick={() => openModal("connectRepo")}>+ connect repo</GhostButton>}
      />
      <LoadError message={loadError} />

      {repos.length === 0 ? (
        <Box ta="center" p="38px 24px">
          <Box c="var(--vf-acc)" fz="14px" mb={8}>
            no repositories connected
          </Box>
          <Box c="var(--vf-dim2)" fz="12px" lh={1.6} maw={420} mx="auto" mb={18}>
            Connect a GitHub repo and VectorForge clones it, chunks with tree-sitter, and re-indexes
            on every push.
          </Box>
          <Button fz="13px" fw={600} onClick={() => openModal("connectRepo")}>
            ▸ connect a repo
          </Button>
        </Box>
      ) : (
        <Box className={css.tiles3}>
          {repos.map((r) => (
            <button
              key={r.id}
              type="button"
              className={css.repoCard}
              onClick={() => openDetail("repo", r.id)}
            >
              <div className={css.repoHead}>
                <span className={css.repoName}>{r.name}</span>
                <span style={{ fontSize: 12 }}>
                  <StatusDot status={r.status} />
                </span>
              </div>
              <div className={css.repoBody}>
                <Row k="vectors" v={compact(r.vectors)} vColor="var(--vf-acc)" />
                <Row k="branches" v={String(r.branches.length)} vColor="var(--vf-text)" />
                <Row
                  k="webhook"
                  v={r.webhook}
                  vColor={r.webhook === "healthy" ? "var(--vf-ok)" : "var(--vf-bad)"}
                />
                <Row k="indexed" v={r.lastIndexed} vColor="var(--vf-sec)" />
              </div>
            </button>
          ))}
        </Box>
      )}
    </Screen>
  );
}

function Row({ k, v, vColor }: { k: string; v: string; vColor: string }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
      <span style={{ color: "var(--vf-dim)" }}>{k}</span>
      <span style={{ color: vColor }}>{v}</span>
    </div>
  );
}
